export default "__VITE_ASSET__DNvlD7bG__"